import React from 'react';
import { Card } from 'react-bootstrap'
import { Form, RadioGroup, Radio } from 'rsuite';
import RedStar from '../../../../../Shared/GenericComponents/RedStar';

function JournalPrivacyCard(props) {
    return (
        <div className="eiRenewalPrivacyCard">
            <Card>
                <Card.Header><h6>Journal & Privacy (Professional)</h6></Card.Header>
                <Card.Body>
                    <p><RedStar /> Please send me the Louisiana Engineer & Land Surveyor Journal to my registered email (<b>{props.emailAddress}</b>): </p>
                    <br />
                    <Form.Group controlId="formBasicCheckbox">
                        <Form.ControlLabel className="d-none">Receive Method</Form.ControlLabel>
                        <Form.Control name="receiveMethod" inline accepter={RadioGroup}>
                            <Radio value="email">Yes</Radio>
                            <Radio value="none">No</Radio>
                        </Form.Control>
                        <Form.HelpText className="d-none">Receive Method</Form.HelpText>
                    </Form.Group>
                    <p><RedStar /> Do you want your email address(es) and telephone number(s), which you have provided us, to be kept private and not made available to vendors requesting rosters for distribution
                        of engineering/land surveying CPD information or to other third parties?</p>
                    <br />
                    <Form.Group controlId="formBasicCheckbox">
                        <Form.ControlLabel className="d-none">Phone and Email Privacy</Form.ControlLabel>
                        <Form.Control name="emailPhonePrivacy" inline accepter={RadioGroup}>
                            <Radio value={true}>Yes, keep private</Radio>
                            <Radio value={false}>No, share when requested</Radio>
                        </Form.Control>
                        <Form.HelpText className="d-none">Phone and Email Privacy</Form.HelpText>
                    </Form.Group>
                </Card.Body>
            </Card>
        </div>
    );
}

export default JournalPrivacyCard;